import { adminAPIService } from './index'

const route = 'redirect-links'

export default {
  create(url) {
    const json = {
      url: url
    }

    const body = `json=${encodeURIComponent(JSON.stringify(json))}`
    return adminAPIService({
      url: route,
      method: 'post',
      data: body,
    })
  },
}